import { styled } from '@mui/material';

export const DialogImage = styled('img')({
  boxShadow: '0px 3px 6px #00000029',
  background: '#FFFFFF 0% 0% no-repeat padding-box',
  opacity: 1,
  borderRadius: '15px',
});
